import { useFrontofficeContext } from "../../../../context/FrontofficeContext";
import { useLoadContext } from "../../../../context/LoadContext";
import PrinterHelper from "../../../../helpers/PrinterHelper";
import useCustomEffect from "../../../../hooks/useCustomEffect";
import useEvaApi, { EvaApiCall } from "../../../../hooks/useEvaApi";
import PrintStepView from "./PrintStepView";

function PrintStep({ controller }) {
  const callEvaApi = useEvaApi();
  const loadContext = useLoadContext();
  const { terminal } = useFrontofficeContext();

  /**
   * UseEffect for initializing
   */
  useCustomEffect(() => {
    onPrint();
  }, []);

  /**
   * This method will print the visitor label
   */
  async function onPrint() {
    if (!terminal?.printer) {
      controller.onNextStep();
      return;
    }

    const loadTag = loadContext.enableLoader("printer_page_print");

    try {
      // NEW PRINTING METHOD
      if (terminal.printer.printer_device_id) {
        const pdf = await PrinterHelper.getPdfFromHtml(
          document.getElementById("[PRINT_LABEL_READONLY]"),
          terminal.printer.label_width,
          terminal.printer.label_height,
          terminal.printer.rotate,
        );

        await callEvaApi(
          new EvaApiCall(
            `printer_devices/${terminal.printer.printer_device_id}/print`,
          )
            .setMethod("POST")
            .setData({
              file: pdf.output,
              width: pdf.pdfWidth,
              height: pdf.pdfHeight,
              dpi: terminal.printer.dpi,
            })
            .setAlertSuccess(false)
            .setAlertError(true),
        );
      }

      // LEGACY PRINTING METHOD
      else {
        const zplCode = await PrinterHelper.getZplFromHtml(
          document.getElementById("[PRINT_LABEL_READONLY]"),
        );
        await PrinterHelper.printZpl(zplCode);
      }
    } finally {
      loadContext.disableLoader(loadTag);
      controller.onNextStep();
    }
  }

  return <PrintStepView controller={controller} />;
}

export default PrintStep;
